import React, { FC, memo } from "react";
import { isString, isObject, isNumber, isNil } from "lodash";
import clsx from "clsx";
import { Controller } from "react-hook-form/dist/index.ie11";
import { MenuPlacement } from "react-select";

import { useSetSelectOption } from "~/hooks/SelectValue";

import CustomSelect from "./CustomSelect";

import s from "./Select.less";
import { TAling } from "~/shared/ui/Fields/Input";

interface IProps {
  id?: string;
  name: string;
  label?: string;
  type?: string;
  control?;
  loading?: boolean;
  error?: string;
  disabled?: boolean;
  vertical?: boolean;
  required?: boolean;
  isHeight?: boolean;
  menuCustom?: boolean;
  newStyle?: boolean;
  isControlPadding?: boolean;
  customClassName?: string;
  customClassDesck?: string;
  options?: string[] | any;
  optionObjects?: object[];
  onScrollBottom?: () => void;
  getSearchText?: (e) => void;
  menuPlacement?: MenuPlacement;
  menuPortalTarget?: HTMLElement | null;
  menuPosition?: "fixed" | "absolute";
  menuListHeight?: string;
  onChangeDecorator?: (any) => void;
  onSelectDecorator?: () => void;
  labelAlign?: TAling;
  defaultValue?: { value: string; label: string };
  newCustomClassNames?: any;
  getEventName?: (name: string) => void;
  woDefaultValue?: boolean;
  placeholder?: string;
  isClearable?: boolean;
}

const SelectUI: FC<IProps> = ({
  id,
  label,
  name,
  type,
  control,
  error,
  loading = false,
  menuCustom = false,
  disabled = false,
  vertical = false,
  required = false,
  isHeight = false,
  newStyle = false,
  isControlPadding = false,
  customClassName = "",
  customClassDesck = "",
  options = [],
  optionObjects = [],
  onScrollBottom,
  getSearchText,
  menuPlacement = "bottom",
  menuPortalTarget,
  menuPosition,
  menuListHeight,
  onChangeDecorator = () => {},
  onSelectDecorator = () => {},
  labelAlign,
  defaultValue,
  newCustomClassNames,
  getEventName = () => {},
  woDefaultValue,
  placeholder,
  isClearable = false,
}) => {
  const selectOption = useSetSelectOption();
  const preparedOptions = options.map((option) => selectOption(option, type));
  const align = labelAlign && { textAlign: labelAlign };
  return (
    <Controller
      control={control}
      name={name}
      {...(woDefaultValue
        ? {}
        : {
            defaultValue:
              defaultValue ||
              preparedOptions[0] ||
              optionObjects[0] ||
              selectOption("common.not_selected"),
          })}
      render={({ value, onChange }) => {
        return (
          <div
            className={clsx({
              [s.s_select]: true,
              [s.select_vertical]: vertical,
              [s.newStyle]: newStyle,
              [s.disabled]: disabled,
              [s.no_label]: !label,
              [customClassName]: true,
            })}
          >
            {label && <label style={align}>{label}</label>}
            <div
              className={clsx(s.desc, {
                [customClassDesck]: true,
              })}
            >
              <CustomSelect
                id={id}
                options={options.length > 0 ? preparedOptions : optionObjects}
                value={
                  value
                  // isString(value) || isNumber(value)
                  //   ? selectOption(value, type)
                  //   : isObject(value) && value
                }
                onChange={(value) => {
                  onChangeDecorator(value);
                  onChange(value);
                  getEventName(name);
                }}
                error={error}
                disabled={disabled}
                isLoading={loading}
                isHeight={isHeight}
                newStyle={newStyle}
                menuPlacement={menuPlacement}
                menuPortalTarget={menuPortalTarget}
                menuPosition={menuPosition}
                getSearchText={getSearchText}
                menuCustom={menuCustom}
                onScrollBottom={onScrollBottom}
                isControlPadding={isControlPadding}
                required={required}
                menuListHeight={menuListHeight}
                onSelectDecorator={onSelectDecorator}
                newCustomClassNames={newCustomClassNames}
                placeholder={placeholder}
                isClearable={isClearable}
              />
            </div>
          </div>
        );
      }}
    />
  );
};
export default memo(SelectUI);
